/* istanbul ignore file */

import {
  createGrid,
  maxBreakpoints,
  minBreakpoints,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const grid = createGrid({
  numberOfColumns: 12,
  rowGapSmall: 16,
  rowGapMedium: 16,
  rowGapLarge: 24,
  rowGapXLarge: 24,
});

export const wrapper = css`
  margin: ${spacing.md}px 0 ${spacing.xxxl}px;
  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      margin: ${spacing.xl}px 0 ${spacing.xxxl}px;
    `,
  )}
`;

export const productListSeparator = css`
  display: none;
  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      display: block;
      grid-column: 1 / -1;
      width: 100%;
      margin: 0;
      border: 0 none;
      border-top: 1px solid var(--neutral-black-30);
    `,
  )}
`;

export const productListSidebar = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
      grid-column: 1 / span 3;
      position: static;
      background-color: transparent;
      backdrop-filter: none;
      padding: 0;
      margin: 0;
    `,
  )};
`;

export const productListWrapper = css`
  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      padding: 0;
    `,
  )};
`;

export const headerContentWrapper = css`
  grid-column: 1 / -1;
`;

export const breadcrumbsContentWrapper = css`
  grid-column: 1 / -1;
  margin-bottom: ${spacing.md}px;

  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      margin-bottom: ${spacing.xl}px;
    `,
  )}
`;

export const linksCarouselSection = css`
  display: flex;
  justify-content: center;
  margin-bottom: ${spacing.sm}px;

  > section {
    width: 100%;
  }
`;

export const relatedCategories = css`
  margin-top: ${spacing.xxxl}px;
  padding: ${spacing.sm}px ${spacing.md}px;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-color: var(--neutral-black-30);
`;

export const productPagesWrapper = css`
  position: relative;
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 4 / span 9;
    `,
  )}
`;
